import Api from '../axios/api';

type CountryCode = 'PL' | 'MD';

export interface TransportConfigResponse {
	data: TransportConfig;
}

export interface TransportConfig {
	id: string;
	countryCode: CountryCode;
	margin: number;
	zones: Record<string, { from: number; to?: number }>;
	categories: Record<string, { from: number; to: number }>;
	priceMatrix: Record<string, { value: Record<string, number> }>;
	updatedAt: string;
}

export type TransportConfigRequest = Omit<TransportConfig, 'id' | 'updatedAt'>;

export class TransportConfigService {
	static getTransportConfig(
		countryCode: CountryCode = 'PL',
	): Promise<TransportConfigResponse> {
		return Api.get('/v1/admin/transport-config', { params: { countryCode } });
	}

	static updateTransportConfig(
		body: TransportConfigRequest,
	): Promise<TransportConfigResponse> {
		return Api.put('/v1/admin/transport-config', body);
	}
}
